import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { initCurrentFranchisor } from './init/actions';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { Helmet } from 'react-helmet';
import LayoutRoot from './LayoutRoot';

class App extends Component {
	componentDidMount() {
		this.props.initCurrentFranchisor();
	}

	render() {
		const { franchisor } = this.props;

		const iconsPath = franchisor.iconsPath || '/icons';

		return <BlockUi blocking={franchisor.initializing} renderChildren={false}>
			<Helmet>
				{Object.keys(franchisor.metaTags).map(key => <meta key={key} name={key} content={franchisor.metaTags[key]} />)}

				<link rel='shortcut icon' href={`${iconsPath}/favicon.ico`} />
				<link rel='icon' type='image/png' sizes="32x32" href={`${iconsPath}/favicon-32x32.png`} />
				<link rel='icon' type='image/png' sizes="16x16" href={`${iconsPath}/favicon-16x16.png`} />
				<link rel='apple-touch-icon' sizes='180x180' href={`${iconsPath}/apple-touch-icon.png`} />
				<link rel='manifest' href={`${iconsPath}/site.webmanifest.json`} />
				<meta name='msapplication-TileColor' content='#8a56a2' />
				<meta name='msapplication-config' content={`${iconsPath}/browserconfig.xml`} />
				<meta name='theme-color' content='#ffffff' />
			</Helmet>
			<Router basename={`/${franchisor.subdirectory}`}>
				<Route component={LayoutRoot} />
			</Router>
		</BlockUi>;
	}
}

const mapStateToProps = state => ({
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps, {
	initCurrentFranchisor
})(App);